export enum UserStatus {
	INVITED = "INVITED",
	EXPIRED = "EXPIRED",
	ACTIVE = "ACTIVE",
	BLOCKED = "BLOCKED",
}
